import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dots",
  "use": "dots-usage",
  "viewBox": "0 0 19 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 5\" id=\"dots\"><path d=\"M14.616 2.192a2.192 2.192 0 1 1 4.385 0 2.192 2.192 0 0 1-4.385 0Zm-7.309 0a2.192 2.192 0 1 1 4.385 0 2.192 2.192 0 0 1-4.385 0ZM0 2.192a2.192 2.192 0 1 1 4.385 0 2.192 2.192 0 0 1-4.385 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol